import { IPeriod } from "backend/model/model";
import { usePeriod } from "backend/model/usePeriod";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import React from "react";

import usePeriodLevels from "../model/usePeriodLevels";

const usePeriodFromString = (period?: string) => {
  const ctx = useAppContext();
  const periods = usePeriod();
  const { data: periodLevels } = usePeriodLevels();
  const usingPeriod = period || ctx.period || "";
  const currentPeriod = React.useMemo(() => {
    let per: IPeriod | undefined;
    periodLevels?.forEach((level) => {
      level.periods.forEach((p) => {
        if (p.name === usingPeriod) {
          per = p;
        }
      });
    });
    return per;
  }, [periods, ctx.period, usingPeriod]);

  return currentPeriod;
};

export default usePeriodFromString;
